import { cn } from '@anytag/shared-utils';
import { ReactNode } from 'react';
import { Switch as AnyUISwitch, SwitchProps as AnyUISwitchProps } from '@anyui/core';
import { HelpIcon } from '../Icon';
import { TextCutter } from '../TextCutter';

export interface SwitchProps extends AnyUISwitchProps {
  hint?: ReactNode; // the question mark help after the label
  loading?: boolean;
}

export const Switch = ({ label, loading, disabled, className, classNames, hint, ...restSwitchProps }: SwitchProps) => (
  <AnyUISwitch
    disabled={disabled || loading}
    className={cn('switch-wrapper', className)}
    classNames={{
      ...classNames,
      switch: cn(
        {
          'cursor-pointer': !disabled,
          'cursor-wait': loading && !disabled
        },
        classNames?.switch
      )
    }}
    label={
      label && hint ? (
        <div className="flex items-center gap-1">
          {typeof label === 'string' ? <TextCutter text={label} /> : label}
          {hint && <HelpIcon help={hint} />}
        </div>
      ) : typeof label === 'string' ? (
        <TextCutter text={label} />
      ) : (
        label
      )
    }
    {...restSwitchProps}
  />
);
